<template>
  <div>
    <b-navbar
      toggleable="lg"
      variant="light"
      align="end"
      class="nav mt-4 mb-5 shadow"
    >
      <b-navbar-toggle target="nav-collapse" />
      <b-collapse id="nav-collapse" is-nav align="end">
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <!--        <b-nav-item @click="setStatus(1)" :active="status == 1">
              Received
            </b-nav-item> -->
            <b-nav-item @click="setStatus(2)" :active="status == 2">
              ODO
            </b-nav-item>
            <b-nav-item @click="setStatus(3)" :active="status == 3">
              SAAQ
            </b-nav-item>

            <b-nav-item @click="setStatus(4)" :active="status == 4">
              Problems
            </b-nav-item>
            <b-nav-item @click="setStatus(5)" :active="status == 5">
              ✔
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: 2,
    };
  },
  methods: {
    setStatus(status) {
      this.status = status;
      this.$emit("set-status", status);
    },
  },
};
</script>

<style>
</style>